// plop-templates/component-index.tsx.hbs
export * from './Faqs';
